export enum OAuthPlatform {
  TikTokAffiliateCreator = "tiktok_affiliate_creator",
  TikTokAccount = "tiktok_account",
}

export enum OAuthScene {
  Login = "login",
  Bind = "bind",
}
